<template>
  <li class="col-6 col-md-3 mb-3">
    <strong>
      <span>{{ title }}:</span>
    </strong>
    
    <div v-if="value != ''">
      <span v-html="value"></span>
      <slot></slot>
    </div>

    <div v-else>
      <span>Keine Angabe</span>
    </div>
  </li>
</template>

<script>
export default {
  name: "PDSDataEntry",
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: '-'
    },
  },
  data () {
    return {}
  },
}
</script>

<style scoped lang="scss">
</style>
